module.exports = __webpack_public_path__ + "fonts/Muli-Black.37700966.woff2";